import { useState } from 'react';
import { BarChart3 } from 'lucide-react';
import { MAINT, maintOf } from '../lib/maint';
import { winterable, winterPending } from '../lib/winter';
import { Snowflake } from 'lucide-react';

const KEYS = ['ok', 'warn', 'defect', 'none'];
const COLORS = { ...MAINT, none: '#94a3b8' };

export default function MaintStats({ t, project, updateProject }) {
  const [all, setAll] = useState(true);
  const objs = [...project.fittings, ...(all ? [...(project.pipes || []), ...(project.pits || [])] : [])];
  if (!objs.length) return null;
  const n = Object.fromEntries(KEYS.map((k) => [k, objs.filter((o) => maintOf(o) === k).length]));
  const checked = objs.length - n.none;
  const pct = (v) => Math.round((v / objs.length) * 100);
  const filter = (k) => document.querySelector('[data-testid="map-wrapper"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' }) || window.dispatchEvent(new CustomEvent('giss-maint-filter', { detail: [k] }));
  return (
    <section className="panel maint-stats" data-testid="maint-stats">
      <div className="ms-head">
        <BarChart3 size={18} /> <b>{t.msTitle}</b>
        <div className="chip-group ms-scope">
          <button className={`chip seg ${all ? 'on' : ''}`} data-testid="maint-stats-all-btn" onClick={() => setAll(true)}>{t.msAll}</button>
          <button className={`chip seg ${!all ? 'on' : ''}`} data-testid="maint-stats-fittings-btn" onClick={() => setAll(false)}>{t.msFittings}</button>
        </div>
      </div>
      <div className="ms-bar" data-testid="maint-stats-bar">
        {KEYS.map((k) => n[k] > 0 && <button key={k} style={{ width: `${pct(n[k])}%`, background: COLORS[k] }} title={t['mt_' + k]} data-testid={`maint-stats-seg-${k}`} onClick={() => filter(k)} />)}
      </div>
      <div className="ms-legend">
        {KEYS.map((k) => (
          <button key={k} className="ms-item" data-testid={`maint-stats-${k}`} onClick={() => filter(k)}>
            <i style={{ background: COLORS[k] }} /> {t['mt_' + k]} <b data-testid={`maint-stats-count-${k}`}>{n[k]}</b> <small>{pct(n[k])} %</small>
          </button>
        ))}
      </div>
      <WinterBar t={t} project={project} updateProject={updateProject} />
      <div className="ms-progress" data-testid="maint-stats-progress">
        <span>{t.msProgress}: <b>{checked} / {objs.length}</b> ({pct(checked)} %)</span>
        <div className="ms-pbar"><i style={{ width: `${pct(checked)}%` }} /></div>
      </div>
    </section>
  );
}

function WinterBar({ t, project, updateProject }) {
  const list = project.fittings.filter(winterable), w = list.filter((f) => f.winter);
  if (!list.length) return null;
  const done = w.filter((f) => f.winter === 'done').length;
  const start = () => window.confirm(t.wiStartQ.replace('{x}', list.length)) && updateProject((p) => ({ ...p, fittings: p.fittings.map((f) => (winterable(f) ? { ...f, ...winterPending(f, t) } : f)) }));
  const end = () => updateProject((p) => ({ ...p, fittings: p.fittings.map((f) => (f.winter ? { ...f, winter: null } : f)) }));
  const show = () => window.dispatchEvent(new CustomEvent('giss-maint-filter', { detail: ['warn'] }));
  return (
    <div className="wi-bar" data-testid="winter-bar">
      <b><Snowflake size={15} /> {t.wiTitle}</b>
      {!w.length && <button className="btn btn-proj btn-sm" data-testid="winter-start-btn" onClick={start}>{t.wiStart} ({list.length})</button>}
      {w.length > 0 && (
        <>
          <span data-testid="winter-progress">{t.wiDone}: <b>{done} / {w.length}</b></span>
          <div className="ms-pbar wi-pbar"><i style={{ width: `${(done / w.length) * 100}%` }} /></div>
          <button className="btn btn-outline btn-sm" data-testid="winter-show-btn" onClick={show}>{t.wiShow}</button>
          <button className="btn btn-outline btn-sm" data-testid="winter-end-btn" onClick={end}>{t.wiEnd}</button>
        </>
      )}
    </div>
  );
}
